import React, { useEffect, useState } from 'react'
import InputWithSuggest from '../../components/InputWithSuggest';
import { MultiSelect, SButton, TextInputWithLabel } from '../../components';
import { useSelector } from 'react-redux';
import { useLocation, useNavigate } from 'react-router-dom';
import ShowAlert from '../../components/ShowAlert';
import { Ceklis } from '../../assets';
import { API_BASE_URL } from '../../config';

function Form({title}) {
    const user = useSelector((state) => state.auth);
    const navigate = useNavigate();
    const location = useLocation();

    const [input, setInput] = useState("");
    const [suggestions, setSuggestions] = useState([]);
    const [loading, setLoading] = useState(false);
    const [loadingLoad, setLoadingLoad] = useState(false);
    
    const [optTherapis,setTherapis] = useState([]);
    const [selectTherapis, setSelectTherapis] = useState(null);

    const [optTreatment,setTreatment] = useState([]);
    const [selectTreatment, setSelectTreatment] = useState(null);
    
    const [isSaving, setIsSaving] = useState(false);

    const [errors, setErrors] = useState({});
    const [showModal, setShowModal] = useState(false);
    const [showNotif, setShowNotif] = useState(false);

    const [hasSelectedSuggestion, setHasSelectedSuggestion] = useState(false);
    const [notifType, setNotifType] = useState('success');
    const [notifMessage, setNotifMessage] = useState('Form has been successfully submitted!');
    
    
    const [form, setForm] = useState({
        patient: '',
        full_name: '',
        appointment_date: '',
        appointment_time: '',
        phone_number:'',
        email: '',
        therapist: '',
        treatment:'',
        notes:'',
        created_by:'',
        status:'',
        no_medical_record:''
    });

    const validateForm = () => {
        const newErrors = {};
        if (!form.appointment_date) newErrors.appointment_date = "Date is required";
        if (!form.appointment_time) newErrors.appointment_time = "Time is required";
        if (!form.full_name) newErrors.full_name = "Name is required";
        if (!form.email) {
            newErrors.email = "Email is required";
        }else if(!/\S+@\S+\.\S+/.test(form.email)){
            newErrors.email = "Invalid email address.";
        }
        if (!form.phone_number) {
            newErrors.phone_number = "Telephone is required.";
        } else if (!/^\d+$/.test(form.phone_number)) {
            newErrors.phone_number = "Telephone must contain only numbers.";
        }
        return newErrors;
    };


    useEffect(() => {
        if (!input.trim()) {
            setSuggestions([]); // Kosongkan saran jika input kosong
            return;
        }
        const fetchSuggestions = async () => {
            setLoading(true);
            try {
                const token = localStorage.getItem('access_token');
                const res = await fetch(
                    `${API_BASE_URL}/auth/patient_get_klinik/${user.user.klinik_id}`, 
                    {
                        method: 'GET',
                        headers: {
                            'Content-Type': 'application/json',
                            ...(token && { Authorization: `Bearer ${token}` }),
                        }
                    }
                );
                if (!res.ok) {
                    const errorData = await res.json().catch(() => ({}));
                    console.log(errorData.message || 'Gagal mengambil data!');
                    return;
                }
                const response = await res.json();  
                const filteredSuggestions = response.data.filter(
                    (p) =>
                        p.full_name.toLowerCase().includes(input.toLowerCase()) ||
                        p.no_medical_record.includes(input)
                );
                setSuggestions(filteredSuggestions);                 
            } catch (error) {
                console.error("Error fetching suggestions:", error);
            } finally {
                setLoading(false);
            }
        };

        const debounceFetch = setTimeout(fetchSuggestions, 300);
        return () => clearTimeout(debounceFetch);
    },[input,user.user.klinik_id]);

    useEffect(() => {
        setLoadingLoad(true);
        
        const fetchTherapis = async () => {
            try {
                const token = localStorage.getItem('access_token');
                const res = await fetch(
                    `${API_BASE_URL}/auth/employee_get_klinik/${user.user.klinik_id}`, 
                    {
                        method: 'GET',
                        headers: {
                            'Content-Type': 'application/json',
                            ...(token && { Authorization: `Bearer ${token}` }),
                        }
                    }
                );

                if (!res.ok) {
                    const errorData = await res.json().catch(() => ({}));
                    console.log(errorData.message || 'Gagal mengambil data!');
                    return;
                }
                const therapists = await res.json(); 
                
                const filterTherapis =  Array.isArray(therapists.data) ? 
                    therapists.data.filter((item) => item.role === 1 || item.role === 3).map(item => ({
                        value: item.id || item.value,
                        label: item.full_name || item.label,
                    })) : [];

                setTherapis(
                    filterTherapis
                );
            } catch (error) {
                console.error("Error fetching therapis:", error);
            }
        };

        const fetchTreatment = async () => {
            try {
                const token = localStorage.getItem('access_token');
                const res = await fetch(
                    `${API_BASE_URL}/auth/master_treatment_get_klinik/${user.user.klinik_id}`, 
                    {
                        method: 'GET',
                        headers: {
                            'Content-Type': 'application/json',
                            ...(token && { Authorization: `Bearer ${token}` }),
                        }
                    }
                );

                if (!res.ok) {
                    const errorData = await res.json().catch(() => ({}));
                    console.log(errorData.message || 'Gagal mengambil data!');
                    return;
                }
                const treatment = await res.json();                   

                setTreatment(
                    Array.isArray(treatment.data)
                        ? treatment.data.map(item => ({
                            value: item.id || item.value,
                            label: item.treatment_name || item.label,
                        }))
                        : []
                );
            } catch (error) {
                console.error("Error fetching treatment:", error);
            } finally {
                setLoadingLoad(false);
            }
        };
        

        fetchTherapis();
        fetchTreatment();
    },[user.user.klinik_id]);

    // Event handler untuk memilih saran
    const handleSuggestionClick = (suggestion) => {
        setInput(`${suggestion.full_name} (${suggestion.no_medical_record})`); 
        setForm({...form,
            id: suggestion.id,
            full_name: suggestion.full_name,
            email: suggestion.email,
            no_medical_record: suggestion.no_medical_record,
            phone_number: suggestion.phone_number
        })
        setHasSelectedSuggestion(true);
        setSuggestions([]);
    };

    const handleChangeTherapis = (e) => {
        setSelectTherapis(e);
        // Transformasi data untuk hanya menyimpan properti `value`
        const transformedTherapis = e.map(item => ({ value: item.value, label: item.label }));
        setForm({...form,therapist: transformedTherapis})
    };
    const handleChangeTreatment = (e) => {
        setSelectTreatment(e);
        // Transformasi data untuk hanya menyimpan properti `value`
        const transformedTreatment = e.map(item => ({ value: item.value, label: item.label }));
        setForm({...form,treatment: transformedTreatment})
    };

    function combineDateTime(date, time) {
        if (!date || !time) return '';
        // Pastikan time hanya hh:mm
        const timePart = time.slice(0, 5);
        return `${date} ${timePart}`;
    }

    const handleSubmit = async () => {
        const newErrors = validateForm();
        if (Object.keys(newErrors).length > 0) {
            setErrors(newErrors);
            return;
        }
        
        setIsSaving(true);

        let noMedicalRecord = form?.no_medical_record || '';

        try {
            const token = localStorage.getItem('access_token');
            // const ids = form.id ? form.id : 0;
            // const checkPatient = await fetch(
            //     `${API_BASE_URL}/auth/patient/id/${ids}`,
            //     {
            //         method: 'GET',
            //         headers: {
            //             'Content-Type': 'application/json',
            //             ...(token && { Authorization: `Bearer ${token}` }),
            //         }
            //     }
            // );
            // let patientExists = false;
            // let patientData = null;
            // if (checkPatient.ok) {
            //     const res = await checkPatient.json();
            //     patientExists = Array.isArray(res.data) && res.data.length > 0;
            //     if (patientExists) {
            //         patientData = res.data[0];
            //         noMedicalRecord = patientData.no_medical_record;
            //     }
            // }

            const newAppointment = {
                full_name: form?.full_name,
                no_medical_record: noMedicalRecord,
                appointment_date: formatDateYMD(form?.appointment_date),
                appointment_time: combineDateTime(
                        formatDateYMD(form?.appointment_date),
                        form?.appointment_time
                    ),
                phone_number: form?.phone_number,
                email: form?.email,
                therapist: form?.therapist[0]?.value || '',
                treatment: form?.treatment[0]?.value || '',
                notes: form?.notes,
                created_by: user.user.id,
                status: 'Pending',
                klinik_id: user.user.klinik_id,
                arrival_status: 1,
                id_user: '',
                created_at: new Date().toISOString().split('T')[0],
            };

            const createAppointment = await fetch(
                `${API_BASE_URL}/auth/appointment/create`,
                {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                        ...(token && { Authorization: `Bearer ${token}` }),
                    },
                    body: JSON.stringify(newAppointment)
                }
            );
            
            if (!createAppointment.ok) {
                const err = await createAppointment.json().catch(() => ({}));
                setNotifType('danger');
                setNotifMessage(err.message || 'Gagal membuat data!');
                setShowNotif(true);
                setIsSaving(false);
                return;
            }

            setShowNotif(true);
            
            setForm({
                full_name: '',
                appointment_date: '',
                appointment_time: '',
                phone_number: '',
                email: '',
                therapist: '',
                treatment: '',
                notes: '',
                created_by: '',
                no_medical_record: '',
                status: '',
                klinik_id: '',
                created_at: '',
            });
            
            setErrors({});
            setSelectTreatment(null);
            setSelectTherapis(null);
        } catch (error) {
            alert('Terjadi kesalahan koneksi!');
            setNotifType('danger');
            setNotifMessage('Failed!');
            setShowNotif(true);
            setIsSaving(false);
        } finally {
            setIsSaving(false);
        }

    }
    // Fungsi untuk menangani penutupan modal notifikasi
    const handleCloseConfirm = () => {
        setShowNotif(false);

        // Navigasi setelah notifikasi ditutup
        const basePath = location.pathname.split('/')[1];
        navigate(`/${basePath}`);
    };

    //DELETE PROSES
    const handleCancel  = () => {
        setShowModal(true); 
    }

    const handleCloseModal = () => {
        setShowModal(false);
    };

    const handleConfirmCancel = () => {
        setShowModal(false);

        const basePath = location.pathname.split('/')[1];
        navigate(`/${basePath}`);
    };

    // Hilangkan error saat input di-highlight
    const handleFocus = (field) => {
        setErrors((prev) => ({ ...prev, [field]: undefined }));
    };

    const formatDateYMD = (date) => {
        if (!date) return '';
        const d = new Date(date);
        const yyyy = d.getFullYear();
        const mm = String(d.getMonth() + 1).padStart(2, '0');
        const dd = String(d.getDate()).padStart(2, '0');
        return `${yyyy}-${mm}-${dd}`;
    };

    return (
        <>
        <div className='tab-content'>
                <div className='tab-pane fade show active'>
                    <div className='d-flex flex-column'>
                        <div className='mb-10 card card-flush py-4'>
                            <div className='card-header'>
                                <div className='card-title'>
                                    <h2>{title}</h2>
                                </div>
                            </div>

                            <div className='card-body pt-0'>
                                
                                <InputWithSuggest
                                    label={'Search Patient'}
                                    type={'text'}
                                    name={'patient'}
                                    placeholder={'Search Patient...'}
                                    value={input}
                                    onChange={(e) => {
                                        setInput(e.target.value)
                                        setHasSelectedSuggestion(false);
                                    }}
                                    loading={loading}
                                    suggestions={suggestions}
                                    map={
                                        suggestions.length > 0 ? (
                                            suggestions.map((s, index) => (
                                                <li
                                                    key={index}
                                                    onClick={() => handleSuggestionClick(s)}
                                                    style={{
                                                        padding: "10px",
                                                        cursor: "pointer",
                                                        borderBottom: "1px solid #eee",
                                                    }}
                                                >
                                                    {s.no_medical_record},{s.full_name},{formatDateYMD(s.date_of_birth)}
                                                </li>
                                            ))
                                        ) : (
                                            input && !loading && !hasSelectedSuggestion && (
                                                <li style={{ padding: "10px", color: "#888" }}>
                                                    Not found
                                                </li>
                                            )
                                        )
                                    }
                                />
                                <div className='mb-10 d-flex flex-column flex-md-row gap-5'>
                                    <div className='flex-row-fluid'>
                                        <TextInputWithLabel
                                            type={'date'}
                                            label={'Appointment Date'}
                                            name={'appointment_date'}
                                            labelClass={'required form-label'}
                                            value={form?.appointment_date}
                                            onChange={(e) => setForm({...form,appointment_date: e.target.value})}
                                            onFocus={() => handleFocus('date')}
                                            style={{
                                                borderColor: errors.appointment_date ? 'red' : '',
                                            }}
                                        />
                                        <label style={{color:'red'}}>{errors.appointment_date}</label>
                                    </div>
                                    <div className='flex-row-fluid'>
                                        <TextInputWithLabel
                                            type={'time'}
                                            label={'Time'}
                                            name={'appointment_time'}
                                            labelClass={'required form-label'}
                                            value={form?.appointment_time}
                                            onChange={(e) => setForm({...form,appointment_time: e.target.value})}
                                            onFocus={() => handleFocus('appointment_time')}
                                            style={{
                                                borderColor: errors.appointment_time ? 'red' : '',
                                            }}
                                        />
                                        <label style={{color:'red'}}>{errors.appointment_time}</label>
                                    </div>
                                </div>

                                <div className='mb-10 fv-row fv-plugins-icon-container'>
                                    <TextInputWithLabel
                                        type={'text'}
                                        label={'Full Name'}
                                        name={'full_name'}
                                        labelClass={'required form-label'}
                                        placeholder={'Full Name'}
                                        value={form?.full_name}
                                        onChange={(e) => setForm({...form,full_name: e.target.value})}
                                        onFocus={() => handleFocus('full_name')}
                                        style={{
                                            borderColor: errors.full_name ? 'red' : '',
                                        }}
                                    />
                                    <label style={{color:'red'}}>{errors.full_name}</label>
                                </div>

                                <div className='mb-10 d-flex flex-column flex-md-row gap-5'>
                                    <div className='flex-row-fluid'>
                                        <TextInputWithLabel
                                            type={'text'}
                                            label={'No Telephone'}
                                            name={'phone_number'}
                                            labelClass={'required form-label'}
                                            placeholder={'Input your number..'}
                                            value={form?.phone_number}
                                            onChange={(e) => setForm({...form,phone_number: e.target.value})}
                                            onFocus={() => handleFocus('phone_number')}
                                            style={{
                                                borderColor: errors.phone_number ? 'red' : '',
                                            }}
                                        />
                                        <label style={{color:'red'}}>{errors.phone_number}</label>
                                    </div>
                                    <div className='flex-row-fluid'>
                                        <TextInputWithLabel
                                            type={'email'}
                                            label={'Email'}
                                            name={'email'}
                                            labelClass={'required form-label'}
                                            placeholder={'Input your email..'}
                                            value={form?.email}
                                            onChange={(e) => setForm({...form,email: e.target.value})}
                                            onFocus={() => handleFocus('email')}
                                            style={{
                                                borderColor: errors.email ? 'red' : '',
                                            }}
                                        />
                                        <label style={{color:'red'}}>{errors.email}</label>
                                    </div>
                                </div>

                                <div className='mb-10 fv-row fv-plugins-icon-container'>
                                    <MultiSelect
                                        classLabel={'form-label'}
                                        label={'Select a Therapist'}
                                        name={'therapist'}
                                        value={selectTherapis}
                                        handleChange={handleChangeTherapis}
                                        options={optTherapis}
                                    />
                                </div>
                                <div className='mb-10 fv-row fv-plugins-icon-container'>
                                    <MultiSelect
                                        classLabel={'form-label'}
                                        label={'Select a Treatment'}
                                        name={'treatment'}
                                        value={selectTreatment}
                                        handleChange={handleChangeTreatment}
                                        options={optTreatment}
                                    />
                                </div>

                                <div className='mb-10'>
                                    <label className='form-label'>Notes</label>
                                    <textarea
                                        id="notes"
                                        name='notes'
                                        rows="6"
                                        value={form?.notes}
                                        onChange={(e) => setForm({...form, notes: e.target.value})}
                                        placeholder="Write your notes or description here..."
                                        style={{
                                            width: "100%",
                                            padding: "10px",
                                            fontSize: "14px",
                                            border: "1px solid #ccc",
                                            borderRadius: "5px",
                                            resize: "vertical",
                                        }}
                                    />
                                </div>
                            </div>
                        </div>

                        <div className="d-flex justify-content-end">
                            <SButton
                                className={ 'btn btn-secondary me-5'}
                                variant={'secondary'}
                                action={handleCancel}
                            >
                                Cancel
                            </SButton>
                            <SButton
                                className={ isSaving ? 'btn btn-secondary' :'btn btn-primary'}
                                children={
                                    isSaving ? 
                                    (
                                        <>
                                            Please Wait...<span className="spinner-border spinner-border-sm me-2"></span>
                                        </>
                                    )
                                    : 'Save'
                                }
                                variant={isSaving ? 'secondary' : 'primary'}
                                action={handleSubmit}
                            >
                                {isSaving ? (
                                    <>
                                     Please Wait...<span className="spinner-border spinner-border-sm me-2"></span>
                                    </>
                                ) : 'Save'}
                            </SButton>
                        </div>

                        {showModal && (
                            <div className="modal fade show d-block" style={{ backgroundColor: 'rgba(0, 0, 0, 0.5)' }}>
                                <div className="modal-dialog modal-dialog-centered">
                                    <div className="modal-content">
                                        <div className="modal-header">
                                            <h5 className="modal-title">Are you sure?</h5>
                                            <button type="button" className="btn-close" onClick={handleCloseModal}></button>
                                        </div>
                                        <div className="modal-body">
                                            <div className='swal2-icon swal2-warning swal2-icon-show d-flex'>
                                                <div className="swal2-icon-content">!</div>
                                            </div>
                                            <div className="swal2-html-container d-block" id="swal2-html-container">
                                                Are you sure you would like to cancel?
                                            </div>
                                        </div>
                                        <div className="modal-footer">
                                            <SButton
                                                className={ 'btn btn-danger'}
                                                variant={'danger'}
                                                action={handleConfirmCancel}
                                            >
                                                {isSaving ? (
                                                    <>
                                                    Please Wait...<span className="spinner-border spinner-border-sm me-2"></span>
                                                    </>
                                                ) : 'Yes, Cancel It!'}
                                            </SButton>
                                            
                                            <button
                                                type="button"
                                                className="btn btn-secondary"
                                                onClick={handleCloseModal}
                                            >
                                                No, Return
                                            </button>
                                            
                                        </div>
                                    </div>
                                </div>
                            </div>
                        )}

                        { showNotif && (
                                <ShowAlert 
                                title={notifType === 'success' ? 'Ok, got it!' : 'Oops!'}
                                message={notifMessage}
                                pic={notifType === 'success' ? Ceklis : undefined}
                                show={showNotif} 
                                setShow={setShowNotif}
                                onClose={notifType === 'success' ? handleCloseConfirm : ''}
                                swal={notifType === 'success' ? 'swal2-success' : 'swal2-danger'}
                                />
                        )}
                    </div>
                </div>
        </div>
        {loadingLoad && (
            <div
                style={{
                position: 'fixed',
                zIndex: 2000,
                top: 0,
                left: 0,
                width: '100vw',
                height: '100vh',
                background: 'rgba(255,255,255,0.6)',
                backdropFilter: 'blur(2px)',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center'
                }}
            >
                <div className="spinner-border text-primary" role="status" style={{ width: 60, height: 60 }}></div>
            </div>
        )}
        </>
    )
}

export default Form